import React from "react";
import PropTypes from "prop-types";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Fade from "@material-ui/core/Fade";
import Paper from "@material-ui/core/Paper";
import PhotoTagSettings from "components/Photos/PhotoTool/Settings/PhotoTagSettings.tsx";

class PhotoSettings extends React.Component {
  constructor(props) {
    super(props);
    this.paperRef = React.createRef();
  }

  render() {
    const { settingsOpen, setSettingsOpen } = this.props;
    if (!settingsOpen)
      return null;
    return (
      <ClickAwayListener onClickAway={(e) => {
        e.target !== this.paperRef.current && setSettingsOpen(false);
      }}>
        <Fade in>
          <Paper
            className={"photo-tool-settings"}
            ref={this.paperRef}
          >
            <PhotoTagSettings />
          </Paper>
        </Fade>
      </ClickAwayListener>
    );
  }
}

PhotoSettings.propTypes = {
  settingsOpen: PropTypes.bool,
  setSettingsOpen: PropTypes.func,
};

export default PhotoSettings;
